import TaskStore from '../../../store/TaskStore'
import TaskManagementStore from '../../../taskManagement/TaskManagementStore'

export const afterTaskCreatedCb = (task) => {
    TaskStore.add(task)
    TaskManagementStore.appendCreatedTaskIds([task.id]);
}


// WEBPACK FOOTER //
// ./web/js/panels/task/createPanel/syncCallbacks.js